<!-- *ngIf="admindata.isAdmin" -->
<!-- Host element carries `.business-banner-top.post-box-shadow.border-radius-bottom-left-right-6`
     (set via @Component host metadata) so the global retargeting in
     `_section-card.scss` matches and the metadata `.hpanel.scroll-header`
     in the parent template stays an adjacent sibling of `.business-banner-top`. -->
<div class="business-banner">
  <div class="banner-shadow"></div>
  <img class="banner-img" [ngStyle]="{ 'background-image': 'url(' + PHOTOURL + globalCommunity.communityBannerDetails.banner + ')' }" />
  <div class="banner-overlay">
    <div class="banner-edit" *ngIf="(CisAdmin || CisSuperAdmin) && !viewasmembers">
      <input type="file" accept=".jpg, .jpeg, .png" #myFileInput (change)="fileChangeEvent($event, template)"
        (click)="myFileInput.value = null" />
      <div class="image-upload"></div>
      <ng-icon name="tablerCamera" aria-hidden="true"></ng-icon>
    </div>
    <div class="banner-profile-image">
         <img class="img-small" [src]="PHOTOURL + globalCommunity.communityBannerDetails.logo"/>
     </div>
  </div>
</div>

<ng-template #template>
  <!-- <div class="modal-header">
       <h5 class="modal-title pull-left">Banner Image </h5>
       <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
         <span aria-hidden="true">&times;</span>
       </button>
     </div> -->
  <!-- <button type="button" style="font-size: 31px; padding-right: 17px; padding-top: 7px" class="close pull-right"
    aria-label="Close" (click)="closePhoto()">
    <span aria-hidden="true">&times;</span>
  </button>
  <h5 style="margin: 10px 10px 10px 10px; padding-top: 10px">Banner Image</h5>
  <hr /> -->


  <div class="modal-content">

    <div style="padding: 14px 14px !important;">
      <label>Banner Image</label>
      <button type="button" class="close pull-right" aria-label="Close" (click)="closePhoto()">
        <span style="font-size: 2.5rem;font-weight: 400;" aria-hidden="true">&times;</span>
      </button>
    </div>
    <hr style="margin: 0px !important; padding: 0px !important">
    <div class="modal-body">
      <image-cropper [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="true" [aspectRatio]="4.5 / 1"
        format="jpeg" (imageCropped)="imageCropped($event)" (cropperReady)="cropperReady()"
        (loadImageFailed)="loadImageFailed()"></image-cropper>
    </div>

    <div class="modal-footer" style="border-radius: 5px;">
      <button class="btn btn-default" (click)="closePhoto()">Cancel</button>
      <button class="btn primary-btn" (click)="imageLoaded()">Apply</button>
    </div>
  </div>



</ng-template>
